<template>
  <div class="who-we-area pt-100 overflow-hidden bg-gondola2 position-relative z-1">
    <div class="container mw-1356">
      <div class="row" data-cues="zoomOut">
        <div class="col-lg-6">
          <div class="who-we-area-content">
            <span class="top-title">{{ c.top_title }}</span>
            <h2 class="text-white">{{ c.title }}</h2>
            <p>{{ c.description }}</p>
            <div class="row align-items-center">
              <div class="col-lg-9">
                <ul class="ps-0 list-unstyled we-are-list">
                  <li v-for="(point, i) in c.bullet_points" :key="i">
                    <i class="ti ti-circle-check"></i>
                    <span>{{ point }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-3">
                <div class="google">
                  <img src="@/assets/images/google.png" alt="google" />
                  <p>Ratings <span>{{ c.rating }}</span></p>
                </div>
              </div>
            </div>
            <RouterLink to="/pricing" class="btn">
              <span class="border-style">Subscribe Now</span>
            </RouterLink>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="who-we-img-wrap">
            <div class="row align-items-end">
              <div class="col-lg-6 col-sm-6">
                <div class="who-we-1 who-we-img">
                  <div class="row">
                    <div class="col-6">
                      <div class="review mb-minus-53">
                        <div class="review-in">
                          <span>{{ c.stat_reviews_label }}</span>
                          <div class="stat-figure">{{ c.stat_reviews }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="review bg-golden">
                        <div class="review-in">
                          <span>{{ c.stat_subscriptions_label }}</span>
                          <div class="stat-figure">{{ c.stat_subscriptions }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img :src="c.image_1_url || whoWe1" alt="who-we" />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6">
                <div class="who-we-2 who-we-img">
                  <img :src="c.image_2_url || whoWe2" alt="who-we" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/images/border-3.png" class="border-3" alt="border" />
    <img src="@/assets/images/shape-10.png" class="shape shape-10" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "WhoWeAre",
  setup() {
    const { content: c } = useContent("who_we_are", {
      top_title: "WHO WE ARE",
      title: "We are proud to offer the best IPTV subscriptions",
      description: "Our Best IPTV subscriptions offer high-quality streaming, with no buffering or lagging.",
      bullet_points: ["Connect several devices at once", "Gig download speeds available everywhere", "Wall-to-wall wifi connection"],
      rating: "4.7",
      stat_reviews: "500K", stat_reviews_label: "FIVE STAR REVIEWS",
      stat_subscriptions: "5.3K", stat_subscriptions_label: "ACTIVE SUBSCRIPTION",
      image_1_url: "", image_2_url: "",
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const whoWe1 = require("@/assets/images/who-we-1.jpg");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const whoWe2 = require("@/assets/images/who-we-2.jpg");
    return { c, whoWe1, whoWe2 };
  },
});
</script>
